import React from 'react'

import { RelativeTimeCard } from '@/shared/components/ui/relative-time-card'
import { getLangCode, useLocale } from '@/shared/i18n'
import { intlFormat } from '@/shared/tools/dates'

export function BasicDateField(props: { value: string | null | undefined }) {
	const currentLocale = useLocale()
	if (props.value) {
		const value = new Date(props.value)

		return (
			<RelativeTimeCard date={value} locale={getLangCode(currentLocale)}>
				<span>{intlFormat(value)}</span>
			</RelativeTimeCard>
		)
	}

	return '-'
}
